import { useEffect, useState } from "react";

/**
 * Cover-style masthead for the "Power Tool" tabs (Redirection Manager, Service Area
 * Buildout, Conversational SEO). Reproduces the cover's eyebrow line + business-name
 * title at the top-left of the tab:
 *
 *   <label> - POWER TOOL        ← eyebrow (Roboto Mono, tracked); "POWER TOOL" in red
 *   BUSINESS NAME               ← cover business name (Oswald, uppercase, themed accent)
 *
 * The business name is the same value the cover shows (localStorage "cover_business_name").
 * Styling lives in app.css under `.pt-head`.
 */
export function PowerToolHeader({ label }: { label: string }) {
  const [name, setName] = useState(() => (localStorage.getItem("cover_business_name") ?? "").trim());

  // Keep in sync if the business name is edited on the cover (same tab writes localStorage
  // synchronously; other tabs fire "storage"; a focus check catches same-tab returns).
  useEffect(() => {
    const sync = () => setName((localStorage.getItem("cover_business_name") ?? "").trim());
    window.addEventListener("storage", sync);
    window.addEventListener("focus", sync);
    return () => {
      window.removeEventListener("storage", sync);
      window.removeEventListener("focus", sync);
    };
  }, []);

  return (
    <div className="pt-head">
      <div className="pt-eyebrow">{label} • <span className="pt-eyebrow-tool">POWER TOOL <svg className="pt-bolt" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" /></svg></span></div>
      {name && <div className="pt-title"><span className="pt-title-name">{name}</span></div>}
    </div>
  );
}
